import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';

import { AuthGuard } from './shared/guards/AuthGuard';
import { CanActivateGuard } from './shared/guards/CanActivateGuard';
import { AppConstant } from './shared/utilities/app.constant';

export const APP_ROUTES: Routes = [
  {
    path: 'login',
    loadChildren: () =>
      import('./pages/login/login.module').then(m => m.LoginModule),
    title: `${AppConstant.APPLICATION_NAME} - Login`,
  },
  {
    path: 'home',
    loadChildren: () =>
      import('./pages/home/home.module').then(m => m.HomeModule),
    title: `${AppConstant.APPLICATION_NAME} - Home Page`,
    canActivate: [CanActivateGuard, MsalGuard],
  },
  {
    path: 'rig/rig-management',
    loadChildren: () => import('./pages/rig/rig.module').then(m => m.RigModule),
    title: `${AppConstant.APPLICATION_NAME} - Rig Management`,
    canActivate: [CanActivateGuard, MsalGuard, AuthGuard],
  },
  {
    path: 'mailbox/mailbox-management',
    loadChildren: () =>
      import('./pages/mailbox/mailbox.module').then(m => m.MailBoxModule),
    title: `${AppConstant.APPLICATION_NAME} - Mailbox Management`,
    canActivate: [CanActivateGuard, MsalGuard, AuthGuard],
  },
  {
    path: 'user',
    loadChildren: () =>
      import('./pages/user/user.routes').then(m => m.USER_ROUTES),
    canActivate: [CanActivateGuard, MsalGuard, AuthGuard],
  },
  {
    path: 'help-center',
    loadChildren: () =>
      import('./pages/help-center/help-center.module').then(
        m => m.HelpVideoModule
      ),
    title: `${AppConstant.APPLICATION_NAME} - Knowledge Center`,
    canActivate: [CanActivateGuard, MsalGuard],
  },
  {
    path: 'live-support',
    loadChildren: () =>
      import('./pages/live-support/live-support.module').then(
        m => m.LiveSupportModule
      ),
    title: `${AppConstant.APPLICATION_NAME} - Live Support`,
    canActivate: [CanActivateGuard, MsalGuard, AuthGuard], // <================ Must have MSAL code
  },
  {
    path: 'alerts/alerts-management',
    loadChildren: () =>
      import('./pages/alert/alert.routes').then(m => m.ALERT_ROUTES),
    title: `${AppConstant.APPLICATION_NAME} - Alert Management`,
    canActivate: [CanActivateGuard, MsalGuard],
  },
  {
    path: 'distribution-list',
    loadComponent: () =>
      import('./pages/distribution-list/distribution-list.component').then(
        m => m.DistributionListComponent
      ),
    title: `${AppConstant.APPLICATION_NAME} - Distribution List`,
    canActivate: [CanActivateGuard, MsalGuard],
  },
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'test',
    loadChildren: () =>
      import('./pages/test/test.component').then(c => c.TestComponent),
    title: `${AppConstant.APPLICATION_NAME} - Dynamic Content`,
  },
  {
    path: '**',
    loadComponent: () =>
      import('./pages/error/error.component').then(m => m.ErrorComponent),
    title: `${AppConstant.APPLICATION_NAME} - Not Found`,
  },
];
